import logo from './logo.svg';
import './App.css';
import OverviewFikstür from './components/Overview/OverviewFikstür';
import { Context } from './Context/Context';
import NoMatch from './components/NoMatch';


import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import Header from './components/Header';
import HeadAll from './components/headtohead/HeadAll';
import Fixture from './components/fixtures/Fixture';
import Tables from './components/Tables/Tables';
import Team from './components/Teams/Team';
import Archive from './components/Archive/Archive';
import { useState  , useContext, useEffect } from 'react';
import {Language}  from './Context/Language';
import StaticAll from './components/Statistics/StaticAll';
import TrackerAll from './components/TrackerAll/TrackerAll';
import { DataFetch } from './Context/DataFetch';
import Pt from './Pt';
import Ptmobile from './Ptmobile';
import Information from './components/Information';






function App() {

  const [loc , setloc] = useState("2346")
  const [loc2 , setloc2] = useState("")
  

  return (
  
     <div className='container' >
      <div className='container-flex'>
      <Router>
      <Context >
      <Language >
        <DataFetch>
        <Header  />
      <Routes>
      <Route  exact   path= {`/h2h/:${"matchId"}/:${"matchId"}/:${"matchId"}/:${"matchId"}/:${"lang"}?`} element={<HeadAll/>} />
      <Route  path='*'   element={<NoMatch/>} />
      <Route  path={`/Fixture/:${"matchId"}/:${"matchId"}/:${"matchId"}/:${"matchId"}/:${"lang"}?`}   element={<Fixture/>} />
      <Route  path={`/Overview/:${"matchId"}/:${"matchId"}/:${"matchId"}/:${"matchId"}/:${"lang"}?`}   element={<OverviewFikstür/>} />
      <Route  path={`/Info/:${"matchId"}/:${"matchId"}/:${"matchId"}/:${"matchId"}/:${"lang"}?`}   element={<Information/>} />

     
      <Route  path={`/Statistics/:${"matchId"}/:${"matchId"}/:${"matchId"}/:${"matchId"}/:${"lang"}?`}    element={<StaticAll/>} />
      <Route  path={`/pt/:${"matchId"}/:${"matchId"}/:${"matchId"}/:${"lang"}?`}    element={<Pt/>} />
      <Route  path={`/pt/:${"matchId"}/:${"matchId"}/:${"matchId"}/:${"matchId"}/:${"lang"}?`}    element={<Ptmobile/>} />
      </Routes>
      </DataFetch>
      </Language>
      </Context>
    </Router>
      </div>

  </div>



 
  );
}

export default App;
